import { useState, useEffect } from 'react';
import FoldersSidebar from './components/FoldersSidebar';
import NotesListSidebar from './components/NotesListSidebar';
import NoteContent from './components/NoteContent';
import MobileView from './components/MobileView';
import { Analytics } from '@vercel/analytics/react';
import supabase from './supabaseClient';

async function fetchCategories(){
    try{
        let { data: categories, error } = await supabase
        .from('categories')
        .select("id, name, emoji")
        .order('id', { ascending: true });

    if (error) {
        console.error('Supabase error fetching categories:', error);
        return [];
    }

    // Fetch places separately and attach them
    if (categories && categories.length > 0) {
        for (let category of categories) {
            let { data: places, error: placesError } = await supabase
                .from('places')
                .select("id, name, href")
                .eq('category_id', category.id);
            
            if (!placesError && places) {
                category.places = places;
            } else {
                category.places = [];
            }
        }
    }

    return categories || [];
    
    } catch (error) {
        console.error('Error in fetchCategories:', error)
        return [];
    }
}

function App() {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [mobileView, setMobileView] = useState('notes');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories().then(data => {
      setCategories(data);
      // Set Start Here as default selected
      setSelectedCategory({ id: 'start-here', name: 'Start Here', isStartHere: true });
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="bg-[#1e1e1e] h-screen w-full flex items-center justify-center">
        <p className="text-[#8E8E93]">Loading...</p>
      </div>
    );
  }

  return (
    <div className="bg-[#1e1e1e] text-[#EBEBF5] h-screen w-full flex overflow-hidden selection:bg-[#FFB400] selection:text-black">
      {/* Mobile View */}
      <div className="md:hidden w-full h-full">
        <MobileView 
          categories={categories}
          selectedCategory={selectedCategory}
          onSelectCategory={setSelectedCategory}
          view={mobileView}
          setView={setMobileView}
        />
      </div>

      {/* Desktop View */}
      <div className="hidden md:flex w-full h-full">
        <FoldersSidebar />
        <NotesListSidebar 
          categories={categories}
          selectedCategory={selectedCategory}
          onSelectCategory={setSelectedCategory}
        />
        <NoteContent category={selectedCategory} />
      </div>

      {/* Mobile floating action button - removed as it's in the footer */}

      <Analytics />
    </div>
  );
}

export default App;
